//import hook react
import React, { useState, useEffect, useRef } from 'react';

//import axios
import axios from 'axios';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Swal from 'sweetalert2';

const UploadUserData = () => {

    const fileRef = useRef();
    const [selectedFile, setSelectedFile] = useState();

    //token
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);

    const fileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    }

    //function "searchHandler"
    const syncHandler = async (e) => {
        e.preventDefault();

        Swal.showLoading();

        //initialize formData
        const formData = new FormData();

        //append data to formData
        if (selectedFile != null) {
            formData.append('file_path', selectedFile);
        }

        //send data to server
        await axios.post(process.env.REACT_APP_API_URL + '/api/uploaduserdata', formData)
            .then((response) => {
                fileRef.current.value = null;
                setSelectedFile(null);
                Swal.hideLoading();
                Swal.fire({
                    title: 'Sukses',
                    text: "Berhasil upload excel",
                    icon: 'success',
                    confirmButtonText: 'Ok'
                });
            })
            .catch((error) => {
                Swal.hideLoading();
                Swal.fire({
                    title: 'Error',
                    text: "Gagal upload excel, silakan ulangi kembali",
                    icon: 'error',
                    confirmButtonText: 'Ok'
                });
            })
    };

    return <div>
        <a href="upload_template.xlsx">
        <button>Download Template</button></a>
        <Form>
            <Form.Group className="mb-3">
                <Form.Label>Upload file (.xls, .xlsx, .xlsm, .xlsb)</Form.Label>
                <Form.Control
                    ref={fileRef}
                    type="file"
                    accept=".xls,.xlsx,.xlsm,.xlsb"
                    onChange={fileChange}
                ></Form.Control>
            </Form.Group>
            <Button variant="primary" onClick={syncHandler}>
                Sync
            </Button>

        </Form>
    </div>
}

export default UploadUserData;